import showErrorForCloudOrUriAttachments from './showErrorForCloudOrUriAttachments';
import { AttachmentFile, AttachmentFileList, AttachmentFileType } from 'owa-attachment-file-types';
import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function filterCloudOrUriFilesAndShowError(
    files: AttachmentFileList,
    infoBar: InfoBarHostViewState
): AttachmentFileList {
    const localFileAttachments: AttachmentFile[] = [];
    const cloudAttachmentFileNames: string[] = [];

    for (let i = 0, file: AttachmentFile; (file = files[i]); i++) {
        if (
            file.fileType === AttachmentFileType.Cloud ||
            file.fileType === AttachmentFileType.CloudSuggestion ||
            file.fileType === AttachmentFileType.ContextualSuggestion ||
            file.fileType === AttachmentFileType.Uri
        ) {
            cloudAttachmentFileNames.push(file.name);
        } else {
            localFileAttachments.push(file);
        }
    }

    //Display infobar, if cloud or uri attachments are present.
    showErrorForCloudOrUriAttachments(cloudAttachmentFileNames, infoBar);

    return localFileAttachments;
}
